<template>
  <div class="game-container" id="game-container">
    <div class="box" :style="getStyle(startGameConfig)" @click="resetCheckStatus">
      <table>
        <tr v-for="(row, i) in diagram" :key="'row_' + i">
          <td v-for="(col, j) in row" :key="'col_' + j">
            <img
              :src="giveMeImagePlease(col.img)"
              :id="col.id + '-img'"
              :style="getStyle(startGameConfig.img)"
              @click="checksImg"
            />
            <div class="desc" v-if="col.desc !== undefined" :style="getStyle(startGameConfig.desc)">
              {{ col.desc }}
            </div>
            <div class="tag" :style="getStyle(startGameConfig.check)">
              <input type="checkbox" :id="col.id" class="regular-checkbox big-checkbox" />
              <label :for="col.id"></label>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
export default {
  name: 'mp-choose-answer04',
  components: {},
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      startData: {},
      initData: { r: 0, c: 0 },
      diagram: [],
    };
  },
  beforeMount() {
    this.newGame();
  },
  mounted() {},
  methods: {
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    newGame() {
      let items = this.shuffle(this.startGameConfig.sample.slice()).slice(
        0,
        this.startGameConfig.chooose > this.startGameConfig.sample.length
          ? this.startGameConfig.sample.length
          : this.startGameConfig.chooose
      );
      this.startData = this.shuffle(items);
      this.diagram = [];
      var k = 0;
      var i = 0;
      var cols =
        this.startGameConfig.columns !== undefined && Number.isInteger(this.startGameConfig.columns)
          ? this.startGameConfig.columns
          : 3;
      do {
        this.diagram[i] = [];
        for (let j = 0; j < cols; j++) {
          if (this.startData.length == k) break;
          this.diagram[i][j] = this.startData[k];
          k++;
        }
        i++;
      } while (k < this.startData.length);
    },
    shuffle(a) {
      if (a.length == 0) return;
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    checksImg(a) {
      let id = a.target.id.split('-');
      if (document.getElementById(id[0]).checked) document.getElementById(id[0]).checked = false;
      else document.getElementById(id[0]).checked = true;
    },
    resetGameAction() {
      this.newGame();
      this.startData.forEach(function (item, i) {
        document.getElementById(item.id).checked = false;
      });
    },
    checkGameAction() {
      var isCorrect = true;
      this.startData.forEach(function (item, i) {
        if (document.getElementById(item.id).checked != item.cor) isCorrect = false;
      });
      return isCorrect;
    },
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      /** @type {Boolean}  return true becouse want to event to propagate  */
      return true;
    },
    getStyle(item) {
      return _.merge({}, this.getCustomStyle(item));
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item !== undefined && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
  },
  computed: {
    checkGame() {
      return this.$store.getters.checkGame;
    },
    resetGameSwitch() {
      return this.$store.getters.resetGame;
    },
  },
  watch: {
    checkGame: function (newStatus, oldStatus) {
      if (newStatus) {
        this.$store.dispatch('checkGame', this.checkGameAction());
        this.$store.commit('CHECK_GAME', false);
      }
    },
    resetGameSwitch(newStatus, oldStatus) {
      if (newStatus) {
        this.resetGameAction();
        this.$store.dispatch('resetGame');
      }
    },
  },
};
</script>

<style lang="scss"></style>
<style lang="scss" scoped>
.game-container {
  display: flex;
  padding-top: 155px;
  padding-left: 90px;
  padding-right: 90px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.box {
  background-repeat: no-repeat;
  position: relative;
  margin: auto;
  display: block;
  text-align: justify;
}

label {
  display: inline;
}

.regular-checkbox {
  display: none;
}

.regular-checkbox + label {
  background-color: #fafafa;
  border: 1px solid #cacece;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0 -15px 10px -12px rgba(0, 0, 0, 0.05);
  padding: 9px;
  border-radius: 3px;
  display: inline-block;
  position: relative;
}

.regular-checkbox + label:active,
.regular-checkbox:checked + label:active {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0 1px 3px rgba(0, 0, 0, 0.1);
}

.regular-checkbox:checked + label {
  background-color: #e9ecee;
  border: 1px solid #adb8c0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0 -15px 10px -12px rgba(0, 0, 0, 0.05),
    inset 15px 10px -12px rgba(255, 255, 255, 0.1);
  color: #078ef2;
}

.regular-checkbox:checked + label:after {
  content: '\2714';
  font-size: 14px;
  position: absolute;
  top: 0;
  left: 3px;
  color: #078ef2;
}

.big-checkbox + label {
  padding: 18px;
}

.big-checkbox:checked + label:after {
  font-size: 28px;
  left: 6px;
}

td {
  position: relative;
  padding: 10px;
}

img {
  width: 280px;
  height: auto;
}

.tag {
  position: absolute;
  right: 0;
  top: 0;
}

.desc {
  position: absolute;
  left: 50%;
  top: 0;
  margin-right: -50%;
  transform: translate(-50%, 0);
}
</style>
